export const APP_STORE_LINK =
  "https://apps.apple.com/app/kai-social/id6479544529";
export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.DowLabs.KaiSocial";
export const WEB_TERMS_URL = "https://getkaiapp.com/terms-of-service";
export const WEB_PRIVACY_URL = "https://getkaiapp.com/privacy";
